import styled from "styled-components";

export const SAddMemberModalContent = styled.div`
  padding: 16px 24px;
`;
